export default __webpack_public_path__ + "static/media/step3.f45c52d4.svg";